export default __webpack_public_path__ + "static/lightning_fast_payments_spanish-88dc6fd1887113e2b7f1065436049c8a.mp4";